import React from "react";
import RadioButton from "../../../../lib/components/RadioButton/RadioButton";

import { capitalizeFirstLetter } from "../../../profile/common/functions";

export default function AddProgramSelector({
  heading,
  values,
  setChecked,
  checked,
}) {
  return (
    <div className="flex flex-col space-y-2 font-serif">
      <div className="font-serif font-semibold whitespace-nowrap">
        {heading}
      </div>
      <div className="flex flex-col flex-wrap pl-3 space-y-2 md:flex-nowrap">
        {values.map((value, id) => (
          <RadioButton
            labelClass={
              "flex flex-row items-center gap-3 font-serif text-base font-normal text-secondary"
            }
            id={id}
            name={heading}
            value={value}
            checked={checked}
            setChecked={setChecked}
            onChange={() => setChecked(value)}
            body={capitalizeFirstLetter(value)}
          />
        ))}
      </div>
    </div>
  );
}
